import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { IconAutomaticGearbox } from '@tabler/icons-react'
import { DraftingCompass, Database } from 'lucide-react'
import { useFeaturesEnable } from '@/hooks/use-feature-enable'
import Heading from '@/components/heading'
import { Main } from '@/components/layout/main'
import { useJobInfo } from '@/pages/job-details/hooks/usejobinfo'
import SidebarNav from '@/pages/settings/components/sidebar-nav'

export const Route = createFileRoute('/_authenticated/jobs/$jobId/configure')({
  component: RouteComponent,
})

function RouteComponent() {
  const { jobId } = useParams({
    from: '/_authenticated/jobs/$jobId/configure',
  })

  const { enableAutomation } = useFeaturesEnable()
  const jobStatus = useJobInfo(jobId).data?.data.status

  const sidebarNavItems = [
    {
      title: 'Export',
      icon: <Database size={18} />,
      href: `/jobs/${jobId}/configure/export`,
      role: ['admin', 'manager', 'recruiter'],
    },
  ]

  if (jobStatus === 'active') {
    sidebarNavItems.push({
      title: 'Publish',
      icon: <DraftingCompass size={18} />,
      href: `/jobs/${jobId}/configure/publish`,
      role: ['admin', 'manager'],
    })

    if (enableAutomation) {
      sidebarNavItems.push({
        title: 'Triggers',
        icon: <IconAutomaticGearbox size={18} />,
        href: `/jobs/${jobId}/configure/triggers`,
        role: ['admin', 'manager'],
      })
    }
  }

  return (
    <>
      <title>Job Configure | Xecubes</title>

      <Main>
        {/* Page Header */}
        <div className='mb-6'>
          <Heading
            title='Job Configuration'
            description='Configure export, publishing, and automation settings'
          />
        </div>

        {/* Layout (same as Settings) */}
        <div className='grid grid-cols-1 gap-4 md:grid-cols-5'>
          {/* Sidebar */}
          <div className='md:col-span-1'>
            <SidebarNav items={sidebarNavItems} />
          </div>

          {/* ✅ CONTENT BOX WITH INTERNAL SCROLL */}
          <div className='md:col-span-4'>
            <div className='flex h-[calc(100vh-260px)] flex-col overflow-hidden rounded-xl border shadow-sm'>
              {/* ✅ SCROLLABLE BODY INSIDE BOX */}
              <div className='flex-1 overflow-y-auto px-5 py-6'>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </Main>
    </>
  )
}
